import React, { Fragment } from 'react';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import IsNumber from 'lodash/isNumber';
import i18next from 'i18next';

export default (path, translatePrefix) => {
  return (value) => {
    if (IsNumber(value)) value = value.toString();
    if (value === 'N/A' || isNil(value) || isEmpty(value)) {
      return <Fragment/>;
    }

    if (path) {
      const value = get(value, path);
      if (translatePrefix && value)
        return i18next.t(`${translatePrefix}.${value}`);
      return value || <Fragment/>;
    }

    return (translatePrefix && value) ? i18next.t(`${translatePrefix}.${value}`) : (value || <Fragment/>);
  };
};
